import React, { Component } from "react";
import Inventorys from "../../api/Inventory";
import "./CountInventory.css";

class CountInventory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: []
        }
    }

    componentDidMount() {
        Inventorys.get('/get-inventory-count')
            .then(res => {
                this.setState({ count: res.data })
            })
            .catch(error => console.log(error));
    }

    render() {
        return (
            <div className="count-main">
                <div className="count-title">
                    TODAY'S PROUCTS <br />ADDED :
                </div>
                <div>
                    <span className="count">{this.state.count}</span>
                </div>
            </div>
        )
    }
}

export default CountInventory;